export default __webpack_public_path__ + "static/media/rocket-league.e93f564c.png";